// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { formatHumanName, resolveId } from '@medplum/core';
import type { Patient, Reference } from '@medplum/fhirtypes';

function firstFormattedName(patient: Patient | undefined): string | undefined {
  if (!patient?.name?.length) {
    return undefined;
  }
  for (const humanName of patient.name) {
    const s = formatHumanName(humanName).trim();
    if (s.length > 0) {
      return s;
    }
  }
  return undefined;
}

/** Human-readable patient label for tables (never a raw `Patient/{id}` reference). */
export function patientDisplayName(patient: Patient | undefined, ref: Reference<Patient> | undefined): string {
  return firstFormattedName(patient) ?? ref?.display?.trim() ?? 'Unknown Patient';
}

export function patientIdFromCoverageSubject(ref: Reference<Patient> | undefined): string {
  return resolveId(ref) ?? '';
}
